// Reference:
// * https://github.com/epicweb-dev/epic-stack/blob/38fbdf3d3c675199da666811be5729720e2da91a/app/entry.client.tsx

// This is Remix's entry point to the browser, revealed via "npx remix reveal"
// for customization.
// * https://remix.run/docs/en/main/start/quickstart#controlling-server-and-browser-entries

import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

// The startTransition() function marks certain updates as transitions. By
// wrapping hydrateRoot() in startTransition(), the hydration process is
// treated as a low-priority update, which helps keep the app responsive by
// allowing React to handle high-priority updates (such as user interactions)
// smoothly.
//
startTransition(() => {
  // Attach the React components to the server-rendered HTML, turning it into a
  // fully interactive React application.
  //
  hydrateRoot(document, <HydratedRouter />);
});
